import { render, staticRenderFns } from "./DevApi.vue?vue&type=template&id=98352132&scoped=true"
import script from "./DevApi.vue?vue&type=script&lang=js"
export * from "./DevApi.vue?vue&type=script&lang=js"
import style0 from "./DevApi.vue?vue&type=style&index=0&id=98352132&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98352132",
  null
  
)

export default component.exports